export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "No records found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak wyników wyszukiwania"])},
        "Loading...": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Łaowanie..."])},
        "Type:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ:"])},
        "Format:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Format:"])},
        "Symbol Table:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tabela Symbolu:"])},
        "Symbol Code:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod Symbolu:"])},
        "Dest. Callsign:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adres Przezn.:"])},
        "Comment:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Komentarz:"])},
        "Message Id:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nr Wiad.:"])},
        "Message:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomość:"])},
        "Latitude:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szerokość:"])},
        "Longitude:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Długość:"])},
        "Speed:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość:"])},
        "Course:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs:"])},
        "Altitude:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysokość:"])},
        "Dist. From Last Pos.:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dystans od Poprz. Poz."])},
        "Temp:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Temp:"])},
        "Pressure:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ciśnienie:"])},
        "Humidity:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wilgotność:"])},
        "Rain 1h:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deszcz 1 godz.:"])},
        "Rain 24h:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deszcz 24 godz.:"])},
        "Rain Midnight:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deszcz od Północy:"])},
        "Wind Direction:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Kierunek:"])},
        "Wind Gust:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Porywy:"])},
        "Wind Speed:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr Prędkość:"])}
      }
    }
  })
}
